import React from 'react'
import { Icon } from '@iconify/react';
import searchOutlined from '@iconify/icons-ant-design/search-outlined';

const SearchProductMerchan = () => {
  return (
    <div className="flex items-center ">
      <div class="flex ml-8">
        <input class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white" type="text" placeholder="Pencarian" aria-label="Full name" />
        <button className="bg-green-100 text-white font-bold py-2 px-4 rounded">
          <Icon icon={searchOutlined} className="text-2xl text-white" />
        </button>
      </div>
    </div>
  )
}

export default SearchProductMerchan